<template>
  <div
  v-if="isFooter"
    class="footer bg-dark"
    :class="[$route.name == 'Dashboard' ? 'has-sidebar' : '']"
  >
    <div class="foot-info shadow p-3 mb-5">
      <div class="row" v-if="$route.name != 'Dashboard'">
        <div class="col-md-3">
          <p>
            <img src="~@/assets/images/location.png" /><br />
            {{$t("message.serc_address")}}
          </p>
        </div>
        <div class="col-md-3">
          <p>
            <img src="~@/assets/images/phone.png" /><br />
            {{$t("message.serc_phone")}}
          </p>
        </div>
        <div class="col-md-2">
          <p><img src="~@/assets/images/email.png" /><br />{{$t("message.email")}}: edu@serc.gov.kh</p>
        </div>
        <div class="col-md-4">
          <div class="text-center">
            {{$t("message.accept")}}:<br />
            <div class="p-2 mt-2" style="border-radius: 12px; background-color:#DCDCDC;">
              <img src="~@/assets/images/acledalogo3.png" class="mr-4 rounded" style="margin-right: 20px; border-radius: 6px;" />
              <img src="~@/assets/images/1_3x.png" />
            </div>
            <!-- <img src="~@/assets/images/verify.png" /> -->
          </div>
        </div>
      </div>
    </div>
    <p style="color:#fff;">{{$t("message.copy_right", { year: currentYear })}}</p>
  </div>
</template>

<script>
export default ({
  computed:{
    isFooter(){
      if(typeof this.$store.getters.getAuthRole != "undefined" 
      || this.$store.getters.getAuthRole.lenght>0
      ){
          //if(this.$store.getters.getAuthRole[0]=='user' ){
          if(this.$route.name == 'Home'){
            return true;
          }else{
            return false;
          }
      }else{
        return true;
      }
    },
    currentYear() {
      const yearStr = new Date().getFullYear().toString();
      if (this.$store.state.lan === 'kh') {
        const khmerDigits = {
          '0': '០',
          '1': '១',
          '2': '២',
          '3': '៣',
          '4': '៤',
          '5': '៥',
          '6': '៦',
          '7': '៧',
          '8': '៨',
          '9': '៩'
        };
        return yearStr.split('').map(digit => khmerDigits[digit] || digit).join('');
      }
      return yearStr;
    }
  }
})
</script>


<style scoped>
.foot-info {
  background-color: #e9ecef;
}
.foot-info img {
  height: 35px;
  margin-bottom: 5px;
}
.has-sidebar {
  margin-left: 200px;
}
.bg-dark{
  display: block;
  position: relative;
  margin-top: 10%;;
}
@media print {
    .bg-dark{
        display: none;
    }
}
</style>
